import { type MCPServerInfo } from '../../types';

const AvalaraDevDocumentationServer: MCPServerInfo = {
  serverId: 'AVALARA_DEV_DOCUMENTATION',
  name: 'Avalara Dev Documentation',
  slug: 'avalara-dev-documentation',
  description:
    "Avalara's official remote MCP server for searching and navigating Avalara's developer documentation. Read-only — surfaces API reference, guides, and code samples to AI assistants.",
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.avalara.com/docs'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default AvalaraDevDocumentationServer;
